import request from './request'
import {
    isObject
} from '@/utils'
import { isWechat } from '../utils'


// 由于需要打通美的荟入口，所以需要校验是否来自美的荟入口，是则采用新的接口

const requestInUrl = (url, params, method = 'POST') => {        
    let req_url     
    if (url.indexOf('Weichat') > -1) {
        req_url = url
    } else {
        req_url = params.from == 'butler' ? url + 'Weichat' : url
    } 
    console.log('--> 请求路径:', req_url)
    return request({
        url:req_url,
        method,
        data: params
    })
}

// 账单缴费页面接口
// charge/billPay/queryOwesTotal
// charge/billPay/queryOwes
// charge/common/queryUserInfo
// charge/common/queryBizConfig
// charge/billPay/payMethodList
// charge/billPay/payConfirm
// charge/billPay/queryPayLogList



// 预缴充值
// charge/common/queryResListByCustId
// charge/common/queryCustListByResId
// charge/preStore/queryCustListForBalance
// charge/preStore/queryBalanceTotal
// charge/preStore/calcMonthlyFee
// charge/preStore/querySchemeList
// charge/preStore/prePayConfirm





/**
 * 获取用户信息
 * @param {Object} params 
 * @returns 
 */
export function queryUserProperty(params) {
    let url = `charge/common/queryUserProperty${params.from && params.from == 'mdh' ? 'Weichat' : ''}`
    return requestInUrl(url, params);
}
/**
 * 获取项目信息（暂用于美的荟）
 * @param {Object} params 
 * @returns 
 */
export function getCummunityInfo(params) {
    let url = `charge/common/querySpaceInfo${params.from && params.from == 'mdh' ? 'Weichat' : ''}`
    return requestInUrl(url, params);
}

/**
 * 获取项目信息
 * @param {Object} params 
 * funcCodes string 空间id （['01fy01']）
 * userId  string 传用户Id
 * @returns 
 */
export function getCommunityList(params) {
    let url = `charge/applica/authority/user/cmntlist${params.from && params.from == 'mdh' ? 'Weichat' : ''}`
    return requestInUrl(url, params);
}

/**
 * 通用-查询总欠费
 * @param {Object} params 
 * communityId: 小区ID,
 * custId: 客户ID,
 * houseId: 房屋Id
 */
export function payOwesTotal(params) {

    const payload = {
        billingCycleStart: '200001',
        billingCycleEnd: '203001',
        ...params
    }
    let url = `charge/billPay/queryOwesTotal${params.from && params.from == 'mdh' ? 'Weichat' : ''}`
    return requestInUrl(url, payload);
}


/**
 * 通用-查询欠费列表
 * @param {Object} params 
 * communityId: 小区ID,
 * custId: 客户ID,
 * houseId: 房屋Id
 */
export function payOwesList(params) {
    const url = `charge/billPay/queryOwes${params.from && params.from == 'mdh' ? 'Weichat' : ''}`
    return requestInUrl(url, params);
}


/**
 * 通用-查询四格用户信息（支付时候的userId）
 */
export function payQueryUserInfo(params) {
    const url = `charge/common/queryUserInfo${params.from && params.from == 'mdh' ? 'Weichat' : ''}`
    return requestInUrl(url, 
        params, 'GET'
    );
}


/**
 * 通用-查询项目个性化
 * @params  {Object} params 
 * @param  {String} params.communityId 项目ID
 * @return {Promise}
 */
export function payQueryBizConfig(params) {
    const url = `charge/common/queryBizConfig${params.from && params.from == 'mdh' ? 'Weichat' : ''}`
    return requestInUrl(url, params);
}

/**
 * 通用-查询小区支持的支付方式（微信、支付宝...）
 * @param {Object} params 
 * communityId: 小区ID,
 * userId: 用户ID
 */
export function payMethodList(params) {
    const url = `charge/billPay/payMethodList${params.from && params.from == 'mdh' ? 'Weichat' : ''}`
    return requestInUrl(url, params);
}

/**
 * 通用-生成支付订单
 * @param {Object} params 
  houseId,
  communityId,
  custId,
  userId,
  disAmount:"0",
  notPayLfree: selectedLiquidatedDamages == 'true' ? 1 : 0 ,//是否暂缓缴违约金，1：是，0或其他：否"
  acctItemIds: this.billingStrSelected,  //缴费账单ID串
  billAmount: selectedLiquidatedDamages ? amountTotal + parseInt(accountTotalLFee) : amountTotal,  //账单总金额(分)，部分缴费时传欠费总额
  payAmount: amountTotal,   //缴费总金额(分)
  appId: MERCHANTID , //微信支付商户号
  payBzCode: payObj.payBzCode,    //从支付方式获取过来的
  payMethod: _payMethod.id,     //从支付方式获取过来的
  payWay: payObj.payWay,    //从支付方式获取过来的
  tradeType: _payMethod.code,    //从支付方式获取过来的
  system:"2048" ,    //固定写法
  method:"payConfirmV2",    //固定写法
  disRuleIdStr:"",   //优惠规则ID串,
  channelCode: "", // 请求入口 "smart-house-keeper", "云邻管家"  "midea-club", "美地荟"
 */
export function payConfirm(params) {
    const url = `charge/billPay/payConfirm${params.from && params.from == 'mdh' ? 'Weichat' : ''}`
    return requestInUrl(url, params);
}



/**
 * 通用-查询客户关联资源列表
 * @param {Object} params 
 * communityId: 真实项目ID,
 * custId: 客户ID,
 * resInstType: 资源类型：1房屋、2车位
 */
export function queryResListByCustId(params) {
    const url = `charge/common/queryResListByCustId${params.from && params.from == 'mdh' ? 'Weichat' : ''}`
    return requestInUrl(url, params);
}


/**
 * 通用 - 查询资源关联客户列表
 * @param {Object} params 
 * communityId: 真实项目ID,
 * resInstId: 资源ID,
 * resInstType: 资源类型：1房屋、2车位,
 * custType: 客户类型，1000业主、1001业主成员、2000租户、2001租户成员、4000访客（取值来源字典表code为CUSTOMER_TYPE）,
 * mainFlag: 是否主业主/主租户，1是，0否
 */
export function queryCustListByResId(params) {
    const url = `charge/common/queryCustListByResId${params.from && params.from == 'mdh' ? 'Weichat' : ''}`
    return requestInUrl(url, params);
}


/**
 * 预存-创建预存支付
 * @param {Obejct} params 
 * communityId: 真实项目ID,
 * userId: C端用户ID,
 * custId: 客户ID,
 * custName: 客户名称,
 * balResList: [{
 *    resInstType: 资源类型,
 *    resInstId: 资源ID,
 *    resInstName: 资源名称,
 *    resInstCode: 资源编码
 * }],
 * balanceSchemeId: 预存方案ID,
 * balanceSchemeName: 预存方案名称,
 * payAmount: 预存金额,
 * desc: 备注
 */
export function prepayConfirm(params) {
    const url = `charge/preStore/prePayConfirm${params.from && params.from == 'mdh' ? 'Weichat' : ''}`
    return requestInUrl(url, params);
    //prePayConfirmWeicha
}


/**
 * 预存-查询可预存账户列表
 * @param {String} params 
 * communityId: 社区Id,
 * userResList: [{
 *    resInstId: 产权Id,
 *    resInstType: 产权类型：1房屋、2车位
 * }]
 */
export function queryCustListForBalance(params) {
    const url = `charge/preStore/queryCustListForBalance${params.from && params.from == 'mdh' ? 'Weichat' : ''}`
    return requestInUrl(url, params);
}


/**
 * 预存-查询预存总余额
 * @param {Object} params 
 * communityId: 真实项目ID,
 * custId: 客户ID,
 * balanceType: 账本类型，3现金账本、4赠送账本 非必填
 */
export function queryBalanceTotal(params) {
    const url = `charge/preStore/queryBalanceTotal${params.from && params.from == 'mdh' ? 'Weichat' : ''}`
    return requestInUrl(url, params);
}


/**
 * 预存-查询预存方案预估金额
 * 预存方案的appCalcFlag=1（表示需要预估费用）时，才调用此接口，否则不调用
 * @param {Object} params
 * communityId: 真实项目ID,
 * custId: 客户ID,
 * custName: 客户名称, 非必填
 * balResList: [{
 *    resInstType: 资源类型, 非必填
 *    resInstId: 资源ID,
 *    resInstName: 资源名称, 非必填
 *    resInstCode: 资源编码  非必填
 * }],
 * balanceSchemeId: 预存方案ID 
 */
export function calcMonthlyFee(params) {
    const url = `charge/preStore/calcMonthlyFee${params.from && params.from == 'mdh' ? 'Weichat' : ''}`
    return requestInUrl(url, params);
}


/**
 * 预存-查询预存方案列表
 * @param {Object} params
 * communityId: 真实项目ID 
 */
export function querySchemeList(params) {
    const url = `charge/preStore/querySchemeList${params.from && params.from == 'mdh' ? 'Weichat' : ''}`
    return requestInUrl(url, params);
}


/**
 * 预存-查询产权列表
 * @param {Object} params
 * communityId: 真实项目ID 
 * resInstType: 产权类型， 1： 房子， 2： 车位
 * custId： 客户ID
 * 
 */
 export function queryResList(params) {
    const url = `charge/common/queryResListByCustId${params.from && params.from == 'mdh' ? 'Weichat' : ''}`
    return requestInUrl(url, params);
}



// 支付方式
export const prePayObj = {
    '1': {
        name: '微信',
        payType: 1,
        payMethod: 1,
        yzyCode: 3,
        payBzCode: 'APP',
        payWay: 'WEIXIN',
        tradeType: 'WFT_APP',
        icon: 'weixinpay'
    },
    '2': {
        name: '支付宝',
        payType: 2,
        payMethod: 2,
        payBzCode: 'APP',
        yzyCode: 2,
        payWay: 'ALIPAY',
        icon: 'alipay'
    },
    '3': {
        // 参数待定
        name: '合并支付',
        payType: 3,
        payMethod: 3,
        payBzCode: 'APP',
        yzyCode: 3,
        payWay: 'MERGE??',
        icon: 'alipay'
    },
}



// WEBPACK FOOTER //
// ./src/api/residentBill.js